exports.toDateTimeFormat = (date, locale = "fi-fi") => {
  return date.toLocaleString(locale, {
    weekday: "short",
    year: "numeric",
    month: locale === "fi-fi" ? "numeric" : "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

exports.toDateFormat = (date, locale = "fi-fi") => {
  return date.toLocaleString(locale, {
    weekday: "short",
    year: "numeric",
    month: locale === "fi-fi" ? "numeric" : "short",
    day: "numeric",
  })
}

exports.toDateShortFormat = (date, locale = "fi-fi") => {
  return date.toLocaleString(locale, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
}

exports.toDateTimeShortFormat = (date) => {
  return date.toLocaleString("default", {
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

exports.toTimeFormat = (date) => {
  const options = {
    timeStyle: "short",
  }

  return date.toLocaleString("fi-FI", options)
}

exports.toVerboseDateFormat = (date, locale = "fi-FI") => {
  const options = {
    weekday: "long",
    year: "numeric",
    month: locale === "fi-FI" ? "numeric" : "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }

  return date.toLocaleString(locale, options)
}

exports.toISODateFormat = (date) => {
  const timezonedDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60 * 1000,
  )
  return timezonedDate.toISOString().split("T")[0]
}

exports.toISODateTimeFormat = (date) => {
  const timezonedDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60 * 1000,
  )
  return timezonedDate.toISOString()
}

// if current time is between two specified dates, return true
const isBetweenDates = (date, startDate, endDate) => {
  return (
    date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime()
  )
}

// get current time and return true if it is between two specified dates
const isCurrentTimeBetweenDates = (startDate, endDate) => {
  return isBetweenDates(new Date(), startDate, endDate)
}

// get yesterday date
exports.getYesterday = () => {
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return yesterday
}

// get tomorrow date
exports.getTomorrow = () => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow
}

// get hour ago from now
exports.getHourAgo = (hours) => {
  const hourAgo = new Date()
  hourAgo.setHours(hourAgo.getHours() - hours)
  return hourAgo
}

// get 0 or 1 randomly
exports.getRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min

exports.isWebinarNowLive = (start, end) => {
  if (!start || !end) return false
  return isCurrentTimeBetweenDates(
    // getRandomInt(0, 1) ? getHourAgo(-0.5) : getTomorrow(),
    start,
    end,
  )
}

exports.getFullYearsSince2018 = (currentDate = new Date()) => {
  const startDate = new Date(2018, 7, 1)
  const diffTime = currentDate - startDate
  const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365.25)
  return Math.floor(diffYears)
}
